import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { DownloadPdfParameter, getPackagingSlipPdf } from "@tKgpco/Services/CustomPackagingSlipPdfService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type PdfParameterParam = HasOnSuccess & DownloadPdfParameter & HasOnError;

type HandlerType = CustomApiHandler<PdfParameterParam, BlobPart>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = (await getPackagingSlipPdf(props.apiParameter)) as unknown as BlobPart;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        const blob = new Blob([props.apiResult], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        // link.setAttribute("download", `${props.apiParameter.packagingSlipId}.pdf`);
        // link.download = `${props.apiParameter.invoiceNumber}.pdf`;
        link.target = "_blank";
        link.click();
        window.URL.revokeObjectURL(`${url}#toolbar=0`);

        if (props.parameter?.onSuccess) {
            props.parameter.onSuccess();
        }
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const getPackagingSlipPrintHandler = createHandlerChainRunner(chain, "GetPackagingSlipPDF");
export default getPackagingSlipPrintHandler;
